import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      height: 24,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      gap: theme.spacing(0.5),
      alignItems: 'center',
    },
    tooltip: {
      maxWidth: 'none',
      padding: theme.spacing(1),
    },
    button: {
      minWidth: 'auto',
      height: 'auto',
      padding: theme.spacing(0.5, 1),
    },
    startIcon: {
      marginRight: theme.spacing(0.5),
    },
  }),
  { name: 'Actions' }
);
